<template>
  <TouchLayout>
    <div class='main'>
        <div class='main-area'>
            <div :style="{ backgroundImage: 'url(' + backgroudImg + ')' }" class='left-box'></div>
            <div class='right-box'>
                <div class='center-wrap'>
                    <input :value='atndNo' readonly type='text' placeholder='회원번호 입력'>
                    <div class='key-pad'>
                        <div class='key-pad-row'>
                            <button @click="input('1')">1</button>
                            <button @click="input('2')">2</button>
                            <button @click="input('3')">3</button>
                        </div>
                        <div class='key-pad-row'>
                            <button @click="input('4')">4</button>
                            <button @click="input('5')">5</button>
                            <button @click="input('6')">6</button>
                        </div>
                        <div class='key-pad-row'>
                            <button @click="input('7')">7</button>
                            <button @click="input('8')">8</button>
                            <button @click="input('9')">9</button>
                        </div>
                        <div class='key-pad-row'>
                            <button class='blue icon-center' @click='resetNumber'> 
                                <span class='txt'>취소</span>
                            </button>
                            <button @click="input('0')">0</button>
                            <button class='blue icon-center' @click='back'>
                                <div class='delete_number_icon'></div>
                            </button>
                        </div>
                    </div>
                    <button class='send-btn' 
                        :class="{
                            'send-btn-enabled' : atndNo.length >= 4,
                        }"
                        @click='attend'
                    >확인</button>
                </div>
            </div>
        </div>
    </div>
    <!-- 직원 호출 얼럿 -->
    <image-alert
        v-if='isCallEmployee'
        imgUrl='/img/icons/alert.png'
        body1='센터에 알림이 발송되었습니다.'
        body2='잠시만 기다려주세요!'
        @close-popup='onClickImageAlert'
    >
    </image-alert>
    <!-- 고객 찾기 실패 얼럿 -->
    <image-alert
        v-if='openNotFoundMemberAlert'
        imgUrl='/img/icons/user.png'
        body1='회원 정보를 찾을 수 없습니다.'
        body2='다시 시도해주세요.'
        :isTimeLimit='true'
        @close-popup='onClickNotFoundMemberAlert'
    >
    </image-alert>
  </TouchLayout>
</template>

<script>
import api from '@/assets/js/api';
import moment from 'moment';
import ImageAlert from '@/components/ImageAlert';
import TouchLayout from '@/layouts/TouchLayout';

export default {
    name: 'touchMain',
    components: {
      TouchLayout,
      ImageAlert,
    },
    data() {
        return {
            atndNo: '', // 출석 번호
            touchImage: [],
            backgroudImg: '', // 초기값
            logoImg: '',
            imageCnt: 0,
            isCallEmployee: false,
            openNotFoundMemberAlert: false,
        };
    },
    computed: {
        centerId() {
            return this.$store.getters['auth/cId'];
        },
    },
    mounted() {
        this.init();
        // this.touchMoniterSetting();
        // this.tryChangeImage();
    },
    created() {
    },
    methods: {
        async init() {
            try {
                const { data } = await this.getCenter();
                this.logoImg = data.logoUrl || '/img/icons/ic_touch_basic_logo.jpg';
                await this.touchMoniterSetting();
                await this.tryChangeImage();
            } catch (error) {
                console.error(error);
            }
        },
        input(number) {
            this.centerCustomerId += number;
            this.atndNo += number;
            if (this.atndNo.length > 8 ) {
                this.atndNo = this.atndNo.slice(0,8);
            }
        },

        // 입력된 인증번호를 초기화하는 함수
        resetNumber() {
            this.atndNo = '';
        },

        // 입력된 인증번호의 나중에 입력한 숫자를 지우는 함수
        back() {
            const length = this.atndNo.length;
            if (length < 0) return;
            this.atndNo = this.atndNo.slice(0, length - 1);
        },

        // 입력한 출석번호를 확인하는 함수
        attend() {
            if (this.atndNo.length === 0) {
                alert('출석번호를 입력 해 주세요.');
            } else { // 출석확인을 시도할경우
                this.checkAttend();
                // this.$router.push({path: `reservation`}); //예약내역이 존재하는경우
                // this.$router.push({path: `nodata`}) //예약내역이 없는경우
            }
        },
        // 출석확인
        async checkAttend() {
            try {
                const { data } = await this.fetchCheckAttend();
                this.$router.push({
                    path: 'reservation/main',
                    query: {
                        centerId: data.centerId,
                        custId: data.centerCustomerId,
                        name: data.name,
                    },
                });
            } catch (error) {
                console.log(error);
                console.log('출석확인이 되지 않습니다.');
                // alert('잘못된 정보입니다. 다시 입력해주시길 바랍니다.');
                this.openNotFoundMemberAlert = true;
                this.resetNumber();
            }
        },
        fetchCheckAttend() {
            console.log('출석번호', this.atndNo);
            return api.post(`/admin/api/center/${this.centerId}/touch/monitor/attendance`, {
                attendNo: this.atndNo,
            });
        },
        // 터치모니터 설정조회
        async touchMoniterSetting() {
            const baseUrl = 'https://fittoday-upload-file.s3-ap-northeast-1.amazonaws.com';
            try {
                const { data } = await this.fetchTouchMoniterSetting();
                console.log(data);
                for (let i = 1; i < 6; i++) {
                    const item = data['centerImage' + `${i}`];
                    if (item) {
                        const urls = item.split('/');
                        this.touchImage.push(`${baseUrl}/${urls[urls.length - 2]}/${encodeURIComponent(urls[urls.length - 1])}`);
                    }
                }
            } catch (error) {
                console.log(error);
                console.log('터치모니터설정을 불러올수없습니다.');
            }
        },
        fetchTouchMoniterSetting() {
            return api.get(`/admin/api/centerTouchMonitorSetting/${this.centerId}`);
        },
        tryChangeImage() {
            if (this.touchImage.length == 0) { // 이미지가 아무것도 설정되지 않았을 때
                this.backgroudImg = '/img/icons/touch_bg.png';
                return;
            }
            this.imageCnt++;
            if (this.imageCnt < this.touchImage.length) { // 배열의 갯수 이내일때
                this.backgroudImg = this.touchImage[this.imageCnt];
            } else if (this.imageCnt >= this.touchImage.length) {
                this.imageCnt = 0;
                this.backgroudImg = this.touchImage[this.imageCnt];
            }

            setTimeout(this.tryChangeImage, 4000); // 재귀로 호출
        },
        getCenter() {
            // 스웨거 검색: 센터 > 센터조회
            return api.get(`/admin/api/center/${this.centerId}`);
        },
        onClickImageAlert() {
            this.isCallEmployee = false;
        },
        onClickNotFoundMemberAlert() {
            this.openNotFoundMemberAlert = false;
        },
    },
};
</script>

<style lang='scss' scoped>

    .delete_number_icon {
        width: 3.2rem;
        height: 3.2rem;
		background: url(/img/icons/delete_number_btn.png) no-repeat;
        background-position: center !important;
        background-size: contain;

        // 라지 (가로 해상도가 1200px 보다 큰 화면에 적용)
        @media (min-width: 1200px) {
            width: 3.2rem; 
            height: 3.2rem;
            background-size: contain;
        }
    }

    .center-wrap {
        input[type=text] {
            // 라지 (가로 해상도가 1200px 보다 큰 화면에 적용)
            @media (min-width: 1200px) {
                height: 6.4rem !important;
                padding-bottom: 1.6rem !important;
                font-size: 4rem !important;
                line-height: 6.4rem !important;
            }
        }
    }

</style>